module.exports = __webpack_public_path__ + "445f4fee4ee7abf653b56ee88f89067e.png";